import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface EditSiteType {
	siteId: string;
	name: string;
	isEnabled?: boolean;
	isDeleted?: boolean;
}

export const editSite = ({
	name,
	siteId,
	isEnabled = true,
	isDeleted = false,
}: EditSiteType) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`sites/update`, {
		name,
		siteId,
		isEnabled,
		isDeleted,
	});
};
